import api from '../../services/api';

export const userManagementApi = {
  // Get all users with filtering and pagination
  async getUsers(params = {}) {
    const searchParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value);
      }
    });

    const response = await api.get(`/users?${searchParams.toString()}`);
    return response.data;
  },

  // Get single user by ID
  async getUser(userId) {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  // Update user profile
  async updateUser(userId, userData) {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  // Update user status (activate/deactivate)
  async updateUserStatus(userId, isActive) {
    const response = await api.put(`/users/${userId}/status`, { isActive });
    return response.data;
  },

  // Update user role
  async updateUserRole(userId, role) {
    const response = await api.put(`/users/${userId}/role`, { role });
    return response.data;
  },

  // Get user activity logs
  async getUserActivity(userId, params = {}) {
    const searchParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value);
      }
    });

    const response = await api.get(`/users/${userId}/activity?${searchParams.toString()}`);
    return response.data;
  },

  // Delete user (soft delete)
  async deleteUser(userId) {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  // Get user statistics
  async getUserStats() {
    const response = await api.get('/users/stats');
    return response.data;
  },

  // Bulk operations
  async bulkUpdateUserStatus(userIds, isActive) {
    const promises = userIds.map(userId => 
      this.updateUserStatus(userId, isActive)
    );
    return Promise.allSettled(promises);
  },

  async bulkDeleteUsers(userIds) {
    const promises = userIds.map(userId => 
      this.deleteUser(userId)
    );
    return Promise.allSettled(promises);
  },

  // Reset all wallet balances to 400
  async resetAllWallets() {
    const response = await api.post('/users/reset-wallets');
    return response.data;
  }
};

export default userManagementApi;